import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';

import { socket } from 'api';
import { deactivateAllEvents } from 'store/actions/events';
import { Signal, GridBox, Grid, TableHead, TableHeadRow, TableHeaders, SubmitAll, SubmitAllPlace } from 'libs/ui';

const test = false;
const demoData = [
  {
    created_at: '2022-04-25T09:40:29.907508+03:00',
    method: 'controller.gate_closed',
    replace: 'controller.gate_closing_failed',
    id: '99471482-c462-11ec-ae5d-feb67f45ce4a',
    message: 'Контроллер проезда: шлагбаум закрыт',
    parking_id: '062',
    source: '062-ENTRY-1-1',
    source_type: 'rack.lane',
    status: 'processed',
    timestamp: '2022-04-25T09:40:29.080701+03:00',
    type: 'info',
    updated_at: '2022-04-25T09:40:29.907514+03:00',
  },
];

export const SignalsGrid = (props) => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const signals = test ? demoData : props.signals;

  const getSignalsList = () => {
    let signalsList = [];

    if (signals) {
      signalsList = signals.map((item, key) => {
        return <Signal view={'confirm'} key={key} {...item} />;
      });
    }

    return signalsList;
  };

  const rightConfirm = window.haveRight('mnemo.confirm_events');

  const closeAll = () => {
    const id = props.source;
    socket.call('confirm_event_by_rack', { target: id });
    dispatch(deactivateAllEvents(id));
  };

  return (
    <GridBox>
      {rightConfirm && !!signals && signals.length > 0 && (
        <SubmitAllPlace>
          <SubmitAll onClick={closeAll}>{t('buttons.Подтвердить все')}</SubmitAll>
        </SubmitAllPlace>
      )}
      <Grid>
        <TableHead>
          <TableHeadRow>
            <TableHeaders width="190">{t('windows.Начало сигнала')}</TableHeaders>
            <TableHeaders>{t('windows.Описание сигнала')}</TableHeaders>
            <TableHeaders align="right" width="190">
              {t('windows.Действия')}
            </TableHeaders>
          </TableHeadRow>
        </TableHead>
        <tbody>{getSignalsList()}</tbody>
      </Grid>
    </GridBox>
  );
};
